import React from 'react'
import classNames from 'classnames'
import moment from 'moment'

// evertel
import { Text, Row, Col } from '@evertel/web/ui'
import { ProfilePic } from '@evertel/web/user'
import { APIDataBlueUser } from '@evertel/types'

interface DocumentVersionCardProps {
    createdBy?: APIDataBlueUser
    createdDate: Date
    isCurrent: boolean
    isOldest: boolean
    isViewing: boolean
    onClick: () => void
}

const DocumentVersionCard: React.FC<DocumentVersionCardProps> = ({
    createdBy,
    createdDate,
    isCurrent,
    isOldest,
    isViewing,
    onClick
}) => {

    const authorName = createdBy
        ? (createdBy.firstName?.trim() || createdBy.lastName?.trim())
            ? `${createdBy.firstName || ''} ${createdBy.lastName || ''}`.trim()
            : (createdBy.email || 'Unknown')
        : 'Unknown'

    return (
        <Row
            role="button"
            tabIndex={0}
            onClick={onClick}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick() } }}
            valign="top"
            className={classNames('document-version-card p-2 rounded-2 mb-2 py-3', { 'document-version-card-viewing': isViewing })}
        >
            <ProfilePic
                userId={createdBy?.id}
                firstName={createdBy?.firstName}
                lastName={createdBy?.lastName}
                imageUrl={createdBy?.publicImage}
                width={24}
                height={24}
                className="me-2 mt-1"
            />
            <Col style={{ minWidth: 0 }}>
                <Row align="between" valign="center" className="mb-1">
                    <Text bold size={13}>
                        {moment(createdDate).format('MMMM Do, YYYY, HH:mm')}
                    </Text>
                    {isViewing &&
                        <Text color="primary" bold size={12}>
                            Viewing
                        </Text>
                    }
                </Row>
                {isCurrent &&
                    <Text size={12} className="mb-1">Current version</Text>
                }
                <Text size={12}>
                    {isOldest ? 'Created by' : 'Updated by'} {authorName}
                </Text>
            </Col>
        </Row>
    )
}

export { DocumentVersionCard }
